/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MembershipTypes {
    angular.module("meevo.plugins.membershipTypes", []);
}